module.exports = __webpack_public_path__ + "8a0c8c4e90d8ac7681629b333225fc86.svg";